import { useCallback } from 'react';
import { FeatureType } from '@types';
import useLangString from './useLangString';

function useGetFeatureTitle() {
  const lang = useLangString(
    {
      [FeatureType.link]: ['超链接', 'Link'],
      [FeatureType.mobile]: ['联系电话', 'Hotline'],
      [FeatureType.map]: ['地图导航', 'Location'],
      [FeatureType.media]: ['查看图文', 'Photo'],
      [FeatureType.text]: ['查看文本', 'Text'],
      [FeatureType.article]: ['查看文章', 'Article'],
      [FeatureType.audio]: ['查看音频', 'Audio'],
      [FeatureType.video]: ['查看视频', 'Video'],
      [FeatureType.seqFrame]: ['查看环物', 'Object VR'],
      [FeatureType.scene]: ['返回', 'Return'],
      [FeatureType.event]: ['事件', 'Event'],
      [FeatureType.miniProgram]: ['小程序', 'Mini Program'],
      [FeatureType.doc]: ['查看PDF', 'PDF'],
      [FeatureType.model3d]: ['3D模型', '3D'],
      [FeatureType.prevScene]: ['上一场景', 'Previous'],
      [FeatureType.nextScene]: ['下一场景', 'Next'],
      _group: ['分组', 'Group'],
    },
    []
  );
  return useCallback(
    (type: FeatureType | '_group') => {
      return lang[type];
    },
    [lang]
  );
}

export default useGetFeatureTitle;
